<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Upsetting Settings, Collected Works</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, graduation thesis</p>
        <p>Upsetting Settings, Collected Works presents graduation theses from the 2019 graduates of the Piet Zwart Institute, Experimental Publishing. The publication was launched within the graduation show Upsetting Settings, at UBIK Rotterdam. The concept behind 'Upsetting settings' arises from the defaults of technology. In every system there are settings predefined by its creators, that most of the time stay untouched by us, as users. It's their default, not ours, but it's up to us to change it. Society is made of similar preset frameworks that we take for granted.
        </p>
        <p>My graduation thesis, <a href="https://project.xpub.nl/is-it-time-to-eat-or-is-there-no-more-time-to-eat/pdf/your-body-will-make-itself-heard.pdf" target="_blank"><i>Your Body Will Make Itself Heard</i></a>, deals with the meal replacement phenomenon occurring in Western countries, within a culture that falls under the sphere of influence of the startup world, driven by entrepreneurial values and libertarian views. To understand the way the role of food is being transformed by technology companies, I follow a path through the history of cooking and gender roles in food preparation, the role technology has in food culture and the way Silicon Valley is appropriating food traditions and knowledge in creating new consumer products for the privileged. At the same time, I explore the potential of future food innovations, in the context of ever increasing abstraction and commodification of food and the labour of cooking.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/upsetting/scan_thesis.png"></b-img>

      </b-col>

      <b-col md="4">
      <b-img class="img-fluid" src="media/upsetting/cover.png"></b-img>

      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'UpsettingPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
